import { useAPI } from '@/services';
import { useGetUserStatus } from '@/userStatus/hooks';

export const useGetRegisterReturnUrl = () => {
  const { status } = useGetUserStatus();
  const { data } = useAPI(['user', 'getRegisterReturnUrl'], {
    input: {
      redirectUrl: null,
    },
    reactQueryOptions: {
      enabled: status === 'GUEST',
      retry: false,
    },
  });
  const extractReturnUrl = () => {
    try {
      if (data?.registerUrl) {
        const url = new URL(data.registerUrl); // throws error if invalid url is passed
        return url.searchParams.get('returnUrl') || '';
      }
    } catch (error) {}
    return '';
  };

  return {
    returnUrl: extractReturnUrl(),
  };
};
